import { render, staticRenderFns } from "./PromotionDialog.vue?vue&type=template&id=52616042&scoped=true"
import script from "./PromotionDialog.vue?vue&type=script&lang=ts"
export * from "./PromotionDialog.vue?vue&type=script&lang=ts"
import style0 from "./PromotionDialog.vue?vue&type=style&index=0&id=52616042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52616042",
  null
  
)

export default component.exports